import React from 'react';
import toast from 'react-hot-toast';
import { Button } from '../../../components/Buttons/Button';
import { L } from '../../../lib/i18n';

type Args = {
    continueFn: () => void;
    continueButtonText: string;
};
const ConfirmDeleteMailToast = ({ continueFn, continueButtonText }: Args) =>
    toast(
        (t) => (
            <div>
                <p>{L('delete_mail_message')}</p>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Button
                        onClick={() => {
                            continueFn();
                            toast.dismiss(t.id);
                        }}
                    >
                        {continueButtonText}
                    </Button>
                    <Button variant="filledPrimary" onClick={() => toast.dismiss(t.id)}>
                        {L('cancel')}
                    </Button>
                </div>
            </div>
        ),
        { duration: Infinity }
    );

export default ConfirmDeleteMailToast;
